export const adaptEducationRequestPayload = ({
  employeeAmount,
  companyAmount,
}) => {
  return {
    centsInPayroll: employeeAmount * 100,
    centsAmountFromFunds: companyAmount * 100,
  };
};
